module.exports = __webpack_public_path__ + "img/porto-3.1cce5910.png";